import moment from "moment"
import styled from "styled-components"
import Timeago from "../timeago/Timeago"
import ChakraTooltip from "../tooltip/ChakraTooltip"
import BulletSeparation from "../ui/BulletSeparation"

const WhenContainer = styled(BulletSeparation)`
  /* prevent text wrapping */
  /* white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; */

  /* font-size: 0.9em; */

  /* .Completion--When--Status {
    font-size: 0.8em;
    margin-left: 5px;
  } */
`

const When = ({ date, tooltip, ...chakraTooltipProps }) => {
  if (!date) return null

  const timeFormat = "MMM D, YYYY h:mm A"
  const completionTooltip =
    tooltip || (date ? moment(date).format(timeFormat) : null)

  return (
    <WhenContainer className="When">
      <ChakraTooltip title={completionTooltip} {...chakraTooltipProps}>
        <Timeago date={date} />
      </ChakraTooltip>
    </WhenContainer>
  )
}

export default When
